export const ACCESS_DENIED_PAGE_TRANSLATIONS = {
  BUTTON_RETURN: 'Retourner',
  NO_ACCESS_MESSAGE: "Désolé, mais l'accès à cette page est restreint.",
};
